import { combineReducers } from 'redux';

export const handleReducers = (reducers) => (state, action) => {
  const appState = state || {};

  if (reducers[action.type]) {
    return reducers[action.type](appState, action);
  }

  return appState;
};

export const handleObjectReducers = (reducers) => {
  const keys = Object.keys(reducers);
  const mapped = keys.map((k) => ({ [k]: handleReducers(reducers[k]) }));

  return combineReducers(mapped.reduce((acc, o) => ({ ...acc, ...o }), {}));
};

export const finalHandleReducers = (reducers) => {
  const appReducers = { ...reducers };

  Object.keys(appReducers).forEach((key) => {
    // eslint-disable-next-line no-underscore-dangle
    const isModule = appReducers[key].__esModule;
    const handler = isModule ? handleReducers : handleObjectReducers;

    appReducers[key] = handler(appReducers[key]);
  });

  return appReducers;
};
